import { useState } from "react"

export const usePageSize = (initPage, initSize) => {
    const [page, setPage] = useState(initPage)
    const [size, setSize] = useState(initSize)

    const handleChangePage = (newPage) => setPage(newPage)

    const handleChangeSize = (newSize) => {
        setSize(newSize)
        setPage(0)
    }

    return {
        page,
        size,
        handleChangePage,
        handleChangeSize
    }
}
